var _defs, _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.605,
    height: 45.169,
    viewBox: "0 0 70.605 45.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.756,
    y1: 1256.683,
    x2: 0.41,
    y2: 1256.142,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f79e20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f69920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#f58c20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f48620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#f38020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f27521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.701,
    y1: 1256.676,
    x2: 0.196,
    y2: 1255.689,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#e06f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#d3602c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#cf5b2e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(-4016.341 -4521.346)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M4016.582,4521.625h70.1v44.63H4016.6Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M4086.444,4546.448s-19.156,13.508-54.236,19.565h54.236Z",
    fill: "#f38020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M4086.686,4521.365h-70.345v45.15h70.6v-45.169h-.26Zm-.242.5V4566h-69.583v-44.128Z",
    fill: "#231f20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M4022.509,4535.17h-2.917v10.219h2.917a5.4,5.4,0,0,0,3.642-1.17,5.11,5.11,0,0,0,1.858-3.921C4027.991,4537.27,4025.742,4535.17,4022.509,4535.17Zm2.342,7.692a3.813,3.813,0,0,1-2.732.818h-.539v-6.763h.539a3.74,3.74,0,0,1,2.732.817,3.437,3.437,0,0,1,1.1,2.546A3.517,3.517,0,0,1,4024.851,4542.862Z",
    fill: "#231f20"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 1.988,
    height: 10.219,
    transform: "translate(4028.92 4535.17)",
    fill: "#231f20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M4035.776,4539.091c-1.189-.446-1.542-.744-1.542-1.283,0-.65.631-1.133,1.486-1.133a2,2,0,0,1,1.6.836l1.04-1.356a4.494,4.494,0,0,0-3.01-1.134,3.019,3.019,0,0,0-3.195,2.936c0,1.412.65,2.137,2.508,2.806a9.733,9.733,0,0,1,1.375.576,1.243,1.243,0,0,1,.594,1.059,1.452,1.452,0,0,1-1.542,1.449,2.384,2.384,0,0,1-2.174-1.356l-1.282,1.245a3.954,3.954,0,0,0,3.531,1.951,3.3,3.3,0,0,0,3.53-3.363C4038.73,4540.67,4038.043,4539.927,4035.776,4539.091Z",
    fill: "#231f20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M4039.343,4540.3a5.287,5.287,0,0,0,5.388,5.333,5.43,5.43,0,0,0,2.49-.595v-2.341a3.178,3.178,0,0,1-2.4,1.115,3.342,3.342,0,0,1-3.437-3.53,3.394,3.394,0,0,1,3.344-3.512,3.285,3.285,0,0,1,2.49,1.152v-2.341a5.074,5.074,0,0,0-2.452-.632A5.381,5.381,0,0,0,4039.343,4540.3Z",
    fill: "#231f20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M4063.052,4542.045l-2.731-6.875h-2.174l4.329,10.479h1.078l4.4-10.479H4065.8Z",
    fill: "#231f20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M4068.867,4545.389h5.648v-1.728h-3.66v-2.75h3.53v-1.728h-3.53v-2.267h3.66v-1.747h-5.648Z",
    fill: "#231f20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M4082.412,4538.2c0-1.914-1.319-3.01-3.623-3.01h-2.954v10.219h1.988V4541.3h.26l2.75,4.106h2.453l-3.215-4.311A2.736,2.736,0,0,0,4082.412,4538.2Zm-4.013,1.69h-.576v-3.1h.613c1.245,0,1.914.52,1.914,1.523C4080.35,4539.332,4079.681,4539.889,4078.4,4539.889Z",
    fill: "#231f20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 5.444,
    cy: 5.444,
    r: 5.444,
    transform: "translate(4047.89 4534.873)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 5.444,
    cy: 5.444,
    r: 5.444,
    transform: "translate(4047.89 4534.873)",
    opacity: 0.65,
    fill: "url(#linear-gradient-2)",
    style: {
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M4083.676,4535.56c0-.186-.13-.278-.334-.278h-.3v.891h.223v-.353l.26.353h.26l-.3-.371A.227.227,0,0,0,4083.676,4535.56Zm-.372.13h-.037v-.241h.037c.112,0,.168.037.168.111C4083.472,4535.653,4083.416,4535.69,4083.3,4535.69Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M4083.379,4534.947a.781.781,0,1,0,.78.78A.785.785,0,0,0,4083.379,4534.947Zm0,1.431a.652.652,0,1,1,.613-.651A.642.642,0,0,1,4083.379,4536.378Z",
    fill: "#231f20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscover);
export default __webpack_public_path__ + "static/media/iconDiscover.d76f7c47d535af0ab99326377eaffe78.svg";
export { ForwardRef as ReactComponent };